export function authHeader2() {
  return {
    "Content-Type": "application/json",
    "Accept": "application/json",
  };
}
